import React, {useEffect} from 'react'
import type {RouteComponentProps} from 'react-router-dom'

import type {RouterParams} from '../types'

const getBasePath = (pathname: string, sharingKey?: string): string => {
  if (!sharingKey) {
    return '/'
  }

  if (pathname.endsWith(`/${sharingKey}`)) {
    return pathname.substring(0, pathname.length - sharingKey.length)
  }

  return '/'
}

const RedirectToHomePage: React.FC<RouteComponentProps<RouterParams>> = props => {
  const {location, history, match} = props
  const {sharingKey} = match.params

  useEffect(() => {
    const basePath = getBasePath(location.pathname, sharingKey)
    const locationDescriptor: Parameters<typeof history.replace>[0] = {
      pathname: basePath,
      search: location.search,
    }

    if (sharingKey) {
      locationDescriptor.hash = sharingKey
    }

    history.replace(locationDescriptor)
  }, [sharingKey, history, location.search, location.pathname])

  return null
}

RedirectToHomePage.displayName = 'RedirectToHomePage'

export {RedirectToHomePage}
